import type { ApiWriteTour } from '#api/model/types.ts';

import type { TourStop } from './TourStop.ts';
import { toCapacityWeightKg } from './tourCapacity.ts';

export type TourFormValues = {
    tourNumber: string;
    driver: string;
    vehicle: string;
    selectedOrderIds: string[];
    maxWeightT?: number;
    maxLoadingMeter?: number;
    maxVolumeLiter?: number;
    maxVolumeCubicMeter?: number;
};

export const ToBackendDTO = (tour: TourFormValues, stopList: TourStop[], trailerId?: string): ApiWriteTour => {
    return {
        search_name: tour.tourNumber,
        driver_id: tour.driver || undefined,
        truck_id: tour.vehicle,
        trailer_id: trailerId || undefined,
        capacity: {
            max_weight_kg: toCapacityWeightKg(tour.maxWeightT),
            max_loading_meter: tour.maxLoadingMeter,
            max_volume_liter: tour.maxVolumeLiter,
            max_volume_cubic_meter: tour.maxVolumeCubicMeter,
        },
        stops: stopList.map((stop, i) => ({
            order_id: stop.orderId,
            type: stop.type === 'load' ? 'load' : stop.type === 'unload' ? 'unload' : 'execute',
            index: i,
            stop_update: stop.stopUpdate,
        })),
    };
};
